import React from 'react';

interface IConditionProps {
    children: React.ReactNode,
    rule?: Function | boolean
}

const Condition = ({ rule, ...props}:IConditionProps) => {
    if (typeof rule === 'function') return <>{rule() && props.children}</>;
    else if (typeof rule === 'boolean') return <>{rule && props.children}</>;
    else return null;
}
export default Condition;